import { TemplateConfig } from '../types';

export const learningProblemSolvingConfig: TemplateConfig = {
  id: 'learning-problem-solving',
  name: '学习问题如何解决',
  description: '帮助分析学习中的问题并找到解决方法',
  cardCount: 4,
  
  fieldDefaults: {
    title: '学习问题如何解决',
    customerQuestion: '在学业中遇到问题，又不知道如何去解决。帮助我在学习中更好的分析和解决问题。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 3 张牌',
      '请输入第 2 行第 2 张牌'
    ],
    cardInfos: [
      '问题核心',
      '障碍和短处',
      '资源和长处',
      '对策'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '🎯'
  }
};